export enum APIState {
  LOADING = 'LOADING',
  EMPTY = 'EMPTY',
  SUCCESS = 'SUCCESS',
  FAIL = 'FAIL',
}
